/**
 * UI Module
 * Handles dark mode, header effects, and visual feedback
 */

function initDarkMode() {
    const themeToggle = document.getElementById('theme-toggle');
    const darkIcon = document.getElementById('theme-toggle-dark-icon');
    const lightIcon = document.getElementById('theme-toggle-light-icon');
    
    if (!themeToggle || !darkIcon || !lightIcon) return;
    
    // Show correct icon
    const isDark = localStorage.theme === 'dark' || 
        (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches);
    
    (isDark ? lightIcon : darkIcon).classList.remove('hidden');
    
    themeToggle.addEventListener('click', () => {
        darkIcon.classList.toggle('hidden');
        lightIcon.classList.toggle('hidden');
        
        const newTheme = localStorage.theme === 'dark' ? 'light' : 'dark';
        document.documentElement.classList.toggle('dark', newTheme === 'dark');
        localStorage.theme = newTheme;
    });
}

function initHeaderShadow() {
    const stickyHeader = document.getElementById('sticky-header-container');
    if (!stickyHeader) return;

    const mainHeader = document.getElementById('main-header');
    const isTransparent = mainHeader && mainHeader.classList.contains('header-transparent');
    let ticking = false;

    window.addEventListener('scroll', () => {
        if (ticking) return;

        window.requestAnimationFrame(() => {
            const scrolled = window.scrollY > 10;
            stickyHeader.classList.toggle('header-shadow', scrolled);
            if (isTransparent) mainHeader.classList.toggle('header-scrolled', scrolled);
            ticking = false;
        });
        ticking = true;
    });
}

function initShareSheet() {
    const shareButton = document.getElementById('share-button');
    if (!shareButton) return;
    
    if (navigator.share) {
        shareButton.addEventListener('click', async () => {
            try {
                await navigator.share({
                    title: document.title,
                    text: document.querySelector('meta[name="description"]')?.content || document.title,
                    url: window.location.href
                });
            } catch (err) {
                if (err.name !== 'AbortError') {
                    console.error('Share failed:', err);
                }
            }
        });
    } else {
        // Fallback: Copy to clipboard
        shareButton.addEventListener('click', () => {
            navigator.clipboard.writeText(window.location.href).then(() => {
                const checkIcon = '<svg class="w-5 h-5 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>';
                const originalHTML = shareButton.innerHTML;
                shareButton.innerHTML = checkIcon;
                setTimeout(() => shareButton.innerHTML = originalHTML, 2000);
            });
        });
    }
}

function initCategoryColors() {
    const primaryTag = document.querySelector('.article .primary-tag-color');
    if (!primaryTag) return;
    
    const tagColors = {
        'technology': '#3b82f6',
        'design': '#8b5cf6',
        'business': '#10b981',
        'lifestyle': '#f59e0b',
        'gaming': '#ef4444',
        'news': '#06b6d4'
    };
    
    const tagName = primaryTag.textContent.toLowerCase().trim();
    const color = tagColors[tagName] || '#6366f1';
    
    document.documentElement.style.setProperty('--accent-color', color);
    document.body.style.transition = 'background-color 0.5s ease';
}
